import SvgIcon from './SvgIcon';

const LogoIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <defs>
      <linearGradient id="a" x1="49.178%" x2="0%" y1="99.178%" y2="50%">
        <stop offset="0%" stopColor="#8E9DFF" stopOpacity=".362" />
        <stop offset="100%" stopColor="#B97BD3" stopOpacity=".71" />
      </linearGradient>
      <linearGradient id="b" x1="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#9BA6EE" />
        <stop offset="100%" stopColor="#9F75B1" />
      </linearGradient>
      <linearGradient id="c" x1="50%" x2="1.318%" y1="100%" y2="2.635%">
        <stop offset="0%" stopColor="#8E9DFF" />
        <stop offset="100%" stopColor="#D68FF3" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#32383F"
        d="M5.5 16H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H5.5z"
      />
      <path
        fill="url(#a)"
        d="M10.875 0H16v16h-5.125a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
        opacity=".4"
        transform="matrix(-1 0 0 1 22.875 0)"
      />
      <path fill="url(#b)" d="M5.5 0H12a4 4 0 0 1 4 4v4H5.5V0z" opacity=".5" />
      <path fill="url(#c)" d="M4 0h4v16H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z" />
    </g>
  </SvgIcon>
);

LogoIcon.propTypes = {
  className: PropTypes.string,
};

export default LogoIcon;
